<template>
  <div class="main">
    <div class="main-left">
      <div class="header-logo">
        <!-- <img src="https://fusion-portal.oss-cn-hangzhou.aliyuncs.com/zjw/static/images/lo.png" alt=""> -->
      </div>
      <div>
        <a-collapse v-model="activeKey">
          <a-collapse-panel :header="item.meta.title" v-for="(item, index) in routesList" :key="String(index)">
            <p v-for="(a, b) in item.children" :key="b" @click="goRouter(a, b)" :style="chooseKey == a.meta.chooseKey
                ? 'background:#1F7FDB;border-right:2px solid #fff'
                : ''
              ">
              {{ a.meta.title }}
            </p>
          </a-collapse-panel>
        </a-collapse>
      </div>
    </div>
    <div class="main-right">
      <div class="header">
        <a-dropdown>
          <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
            <!-- <img
              v-if="userModel.faceLogo"
              :src="userModel.faceLogo"
              @click="userInfo"
              alt
            />
            <img
              v-else
              src="@/assets/layout/person.png"
              @click="userInfo"
              alt
            /> -->
            <p style="color: black">{{ userModel.userName }}</p>
          </a>
          <a-menu slot="overlay" @click="onClick">
            <a-menu-item key="1">
              <a @click="changeInfo">修改信息</a>
            </a-menu-item>
            <a-menu-item key="2">
              <a @click="loginout">退出登录</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>

        <!-- <a-button class="btn" v-if="subsStatus != 1">实名认证未完成</a-button> -->
      </div>
      <div class="content">
        <router-view></router-view>
      </div>
    </div>
  </div>
  <!-- <div class="bo">
    <div class="sidebar-container">
      <div class="sidebar-left">
        <img src="@/assets/layout/titlelogo2.png" alt="" />
        <span style="line-height: 80px; margin-left: 13px">客户端订阅号</span>
      </div>
      <div class="sidebar-right">
        <a-dropdown>
          <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
            <img
              v-if="userModel.faceLogo"
              :src="userModel.faceLogo"
              @click="userInfo"
              alt
            />
            <img
              v-else
              src="@/assets/layout/person.png"
              @click="userInfo"
              alt
            />
          </a>
          <a-menu slot="overlay" @click="onClick">
            <a-menu-item key="1">
              <a @click="loginout">退出登录</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>

        <p>{{ userModel.likeName }}</p>
        <a-button class="btn" v-if="subsStatus != 1">实名认证未完成</a-button>
      </div>
    </div>
    <div class="app-wrapper">
      <div class="app-wrapper-left" v-if="dyhState == 1">
        <a-menu
          :selected-keys="selectedKey"
          :open-keys.sync="openKey"
          mode="vertical"
          theme="light"
        >
          <template v-for="(e, i) in routesList">
            <template
              v-if="
                e.children.length == 0 &&
                e.path != 'userInfo' &&
                subsStatus == 1
              "
            >
              <a-menu-item @click="handlerClickMenu(e.path)" :key="e.path">
                <img
                  :src="
                    route.indexOf(e.path) !== -1
                      ? e.meta.activeIcon
                      : e.meta.icon
                  "
                  height="16px"
                  class="icon"
                  alt=""
                />
                <span>{{ e.meta.title }}</span>
                <div class="diliver" />
              </a-menu-item>
            </template>
            <template
              v-else-if="e.children.length != 0 && e.path != 'userInfo'"
            >
              <a-sub-menu :key="e.path">
                <span slot="title">
                  <a-icon :type="e.meta.icon" />
                  <span>{{ e.meta.title }}</span>
                </span>
                <a-menu-item
                  v-for="(ce, ci) in e.children"
                  @click="handlerClickMenu(e.path, ce.path)"
                  :key="e.path + '/' + ce.path"
                  >{{ ce.meta.title }}</a-menu-item
                >
              </a-sub-menu>
            </template>
          </template>
        </a-menu>
      </div>
      <div class="main-container" style="width: 100%">
        <div class="main-container-content">
          <div class="container-content">
            <transition name="fade-transform" mode="out-in">
              <router-view />
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
import { getSubsInfo } from "@/api/subscription";
import { getUserInfo } from "@/api/userManage";
import changeTheme from "./components/changeTheme.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Layout",
  components: {
    changeTheme,
  },
  computed: {
    ...mapGetters(["dyhState"]),
  },
  data() {
    return {
      route: "",
      collapsed: false,
      routes: [], //一级栏目
      routesList: [], //二级栏目
      matched: "",
      activeKey: ["0", "1", "2"],
      selectedKey: "", //选中栏目
      openKey: "", //展开栏目
      userModel: {}, //用户信息
      subsStatus: 0, //订阅号申请状态
      chooseKey: 0,
    };
  },

  watch: {
    $route: {
      handler: function (val) {
        this.chooseKey = val.meta.chooseKey;
        // this.getKey();
        // this.getFirstRouterName();
        // this.getSecondRouterName();
        // this.route = val.path;
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions(["setSubsState"]),
    goRouter(val, b) {
      console.log(val);
      this.chooseKey = val.meta.chooseKey;
      this.$router.push(val.path);
    },
    userInfo() {
      this.$router.push("/ugc/userInfo");
    },
    //获取一级栏目
    getFirstRouterName() {
      // this.routes = this.$router.options.routes;
      // this.routes = this.routes.filter((item) => item.meta.isFirst);
      // console.log(this.routes);
      // console.log(this.routes);
    },
    //获取二级栏目
    getSecondRouterName() {
      // let routes = this.$router.options.routes;
      // this.matched = routes.filter(
      //   (item) => this.$route.path.indexOf(item.path) == 0
      // );
      // this.routesList = this.matched[0].children;
      // let arr = JSON.parse(localStorage.getItem("userModel"));
      // if(arr.userType=="declarator") {
      //   this.routesList=this.routesList.splice(0,1)
      // }
      // if(arr.userType=="expert") {
      //   this.routesList=this.routesList.splice(2,1)
      // }
      // if(arr.userType=="cityAdm") {
      //   this.routesList=this.routesList.splice(0,2)
      // }
      // console.log(this.routesList);
    },
    //获取选中key和展开key
    getKey() {
      switch (this.$route.path.split("/").length) {
        case 5:
          this.selectedKey = [
            this.$route.path.split("/").slice(-3)[0] +
            "/" +
            this.$route.path.split("/").slice(-2)[0],
          ];
          this.openKey = [this.$route.path.split("/").slice(-3)[0]];
          break;
        case 4:
          this.selectedKey = [
            this.$route.path.split("/").slice(-2)[0] +
            "/" +
            this.$route.path.split("/").pop(),
          ];
          this.openKey = [this.$route.path.split("/").slice(-2)[0]];
          break;
        case 3:
          this.selectedKey = [this.$route.path.split("/").pop()];
          this.openKey = [];
          break;
        case 2:
          this.selectedKey = [this.$route.path.split("/").pop()];
          this.openKey = [];
          break;

        default:
          this.selectedKey = [];
          this.openKey = [];
          break;
      }
    },
    //一级栏目点击
    handlerFirstClickMenu(item) {
      this.$router
        .push({
          path:
            item.path +
            "/" +
            item.children[0].path +
            `${item.children[0].children.length > 0
              ? "/" + item.children[0].children[0].path
              : ""
            }`,
        })
        .catch((e) => { });
    },
    //二级栏目点击
    handlerClickMenu(path1, path2) {
      if (path1 == "editarticle") {
        sessionStorage.removeItem("articleContent");
        sessionStorage.removeItem("manuscript");
      }
      this.$router
        .push({
          path:
            this.matched[0].path + "/" + path1 + `${path2 ? "/" + path2 : ""}`,
        })
        .catch((e) => { });
    },

    //收缩
    changeCollased() {
      this.collapsed = !this.collapsed;
    },
    onClick({ key }) {
      // this.$router
      //   .push({
      //     path: "/",
      //   })
      //   .catch((e) => {});
    },
    // 修改信息
    changeInfo() {
      if (
        JSON.parse(sessionStorage.getItem("userModel")).userType == "expert"
      ) {
        // sessionStorage.setItem("userModel");
        this.$router.push("/complete-information");
      } else {
        this.$router.push("/modifyInformation");
      }
    },
    // 退出登录
    loginout() {
      localStorage.removeItem("token");
      localStorage.removeItem("userinfo");
      localStorage.removeItem("userModel");
      sessionStorage.removeItem("userModel");
      sessionStorage.removeItem("subscribe");
      sessionStorage.removeItem("subscribeInfo");
      sessionStorage.removeItem("dyhState");
      sessionStorage.removeItem("subsId");
      // 刷新页面 通过路由守卫回到登陆页
      this.$router.go(0).catch((e) => {
        console.log(e);
      });
    },
    // 获取用户信息
    async getSubscriptionInfo() {
      let form = {
        Authorization: localStorage.getItem("token"),
      };
      getUserInfo(form).then((res) => {
        if (res.status) {
          // this.subsDataList=res.data.subscribe
          // this.subscribeInfo=res.data.subscribeInfo
          this.userModel = res.data.userModel;
          sessionStorage.setItem(
            "userModel",
            JSON.stringify(res.data.userModel)
          );
        }
      });
    },
    //获取订阅号id
    async getSubsId() {
      getSubsInfo({}).then((res) => {
        if (res.status) {
          if (res.data.hasOwnProperty("subscribe")) {
            sessionStorage.setItem(
              "subsId",
              res.data.subscribeInfo[0].subscribeId
            );
            sessionStorage.setItem(
              "subscribe",
              JSON.stringify(res.data.subscribe[0])
            );
            sessionStorage.setItem(
              "subscribeInfo",
              JSON.stringify(res.data.subscribeInfo[0])
            );
            if (
              res.data.subscribe[0].status == 1 &&
              res.data.subscribeInfo[0].auditorStatus == 1
            ) {
              this.subsStatus = 1;
              sessionStorage.setItem("dyhState", 1);
              this.setSubsState(1);
            } else {
              this.subsStatus = 0;
              sessionStorage.setItem("dyhState", 0);
              this.$router.push("/ugc/userInfo");
            }
          } else {
            this.subsStatus = 0;
            sessionStorage.setItem("dyhState", 0);
            this.$router.push("/ugc/userInfo");
          }

          // localStorage.setItem('subscribeStatus',res.data.subscribe[0].status)
        } else {
          sessionStorage.setItem("dyhState", 0);
          this.$router.push("/ugc/userInfo");
        }
      });
    },
  },
  async created() {
    this.chooseKey = this.$route.meta.chooseKey;
    if (localStorage.getItem("userModel")) {
      this.userModel = JSON.parse(localStorage.getItem("userModel"));
    }
    let routes = this.$router.options.routes;
    this.matched = routes.filter(
      (item) => this.$route.path.indexOf(item.path) == 0
    );
    this.routesList = this.matched[0].children;
    let arr = JSON.parse(localStorage.getItem("userModel"));
    if (arr.userType == "declarator") {
      this.routesList = this.routesList.splice(0, 1);
    }
    if (arr.userType == "expert") {
      this.routesList = this.routesList.slice(2, 3);
      this.$router.push("/skl/expertReview/projectDeclaration");
    }
    if (arr.userType == "cityAdm") {
      this.routesList = this.routesList.splice(0, 2)
      this.routesList[0].children.splice(1, 3)
    }
    console.log(this.routesList);
    // await this.getSubscriptionInfo();
    // await this.getSubsId();
    // if(!localStorage.getItem('userModel')){
    //   await this.getSubscriptionInfo()
    // }else{
    //   this.userModel=JSON.parse(sessionStorage.getItem('userModel'))
    //   sessionStorage.setItem("userModel" ,JSON.stringify(res.data.userModel))
    // }
    // if(!sessionStorage.getItem('subscribe')||!sessionStorage.getItem('subscribeInfo')){
    //   this.getSubsId()
    // }else{
    //   let subsData=JSON.parse(sessionStorage.getItem('subscribe'))
    //   let subsInfo=JSON.parse(sessionStorage.getItem('subscribeInfo'))
    //   if(subsData.status==1&&subsInfo.auditorStatus==1){
    //     this.subsStatus=1
    //   }else{
    //     this.subsStatus=0
    //   }
    //   // localStorage.setItem('subscribeStatus',res.data.subscribe[0].status)
    //   if(subsData.status!=1){
    //     this.$router.push('/ugc/userInfo')
    //   }
    // }
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
<style lang="scss">
.ant-menu-submenu {
  .ant-menu-sub {
    background: $left-second-level-bj-color;

    .ant-menu-item-selected {
      background: $choose-color;
    }

    .ant-menu-item {
      color: $font-color;
    }
  }
}
</style>
